const KEY = 'ss.lastSlug';

export function getLastSlug(): string | null {
  try {
    return window.localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function setLastSlug(slug: string): void {
  try {
    window.localStorage.setItem(KEY, slug);
  } catch {
    // Ignore — private mode etc.
  }
}
